<div data-testId="ecg-symptom-descriptions">
  <div class="strong">{{ 'uploadFormLabelSymptoms' | localize }}</div>
  <div class="multiline">
    <div
      *ngFor="let symptom of ecgSymptoms"
      class="d-flex gap-3"
    >
    <span>
      {{ symptom.time | appLocalDateTime }}
    </span>
      <span>
      {{ symptom.description }}
    </span>
    </div>
  </div>
</div>
